import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const Utah = () => {
  const [showCities, setShowCities] = useState(false);

  useEffect(() => {
    // Set document title and meta tags
    document.title = 'We Buy Surplus Valves Utah | Fisher Valves Rosemount Utah Industrial Equipment Buyers';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional surplus valve buyers throughout Utah. We buy Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from Salt Lake City, Provo refineries and industrial facilities at above scrap rates.');
    }
    
    // Set meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'utah valve buyers, we buy valves utah, surplus valve buyers utah, fisher valves utah, rosemount transmitters utah');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/utah');
    
    // Set Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'We Buy Surplus Valves Utah | Fisher Valves Rosemount Utah Industrial Equipment Buyers' },
      { property: 'og:description', content: 'Professional surplus valve buyers throughout Utah. We buy Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from Salt Lake City, Provo refineries.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/utah' },
      { property: 'og:type', content: 'website' }
    ];
    
    ogTags.forEach(tag => {
      let ogTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!ogTag) {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', tag.property);
        document.head.appendChild(ogTag);
      }
      ogTag.setAttribute('content', tag.content);
    });
    
    // Set geo location tags
    let geoPosition = document.querySelector('meta[name="geo.position"]');
    if (!geoPosition) {
      geoPosition = document.createElement('meta');
      geoPosition.setAttribute('name', 'geo.position');
      document.head.appendChild(geoPosition);
    }
    geoPosition.setAttribute('content', '39.3210;-111.0937');
    
    let geoRegion = document.querySelector('meta[name="geo.region"]');
    if (!geoRegion) {
      geoRegion = document.createElement('meta');
      geoRegion.setAttribute('name', 'geo.region');
      document.head.appendChild(geoRegion);
    }
    geoRegion.setAttribute('content', 'US-UT');
    
    let geoPlacename = document.querySelector('meta[name="geo.placename"]');
    if (!geoPlacename) {
      geoPlacename = document.createElement('meta');
      geoPlacename.setAttribute('name', 'geo.placename');
      document.head.appendChild(geoPlacename);
    }
    geoPlacename.setAttribute('content', 'Utah, United States');
    
    // Set last-modified
    let lastModified = document.querySelector('meta[http-equiv="last-modified"]');
    if (!lastModified) {
      lastModified = document.createElement('meta');
      lastModified.setAttribute('http-equiv', 'last-modified');
      document.head.appendChild(lastModified);
    }
    lastModified.setAttribute('content', new Date().toISOString());

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          "@id": "https://valvesalessupply.com/utah/#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Service Areas",
              "item": "https://valvesalessupply.com/service-areas"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Utah",
              "item": "https://valvesalessupply.com/utah"
            }
          ]
        },
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/utah/#webpage",
          "url": "https://valvesalessupply.com/utah",
          "name": "We Buy Surplus Valves Utah | Fisher Valves Rosemount Utah Industrial Equipment Buyers",
          "description": "Professional surplus valve buyers throughout Utah. We buy Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from Salt Lake City, Provo refineries and industrial facilities at above scrap rates.",
          "breadcrumb": {
            "@id": "https://valvesalessupply.com/utah/#breadcrumb"
          },
          "inLanguage": "en-US",
          "isPartOf": {
            "@id": "https://valvesalessupply.com/#website"
          }
        },
        {
          "@type": "Product",
          "@id": "https://valvesalessupply.com/utah/#fisher-valves",
          "name": "Fisher Control Valves - Utah Surplus Valve Buyers",
          "description": "We buy surplus Fisher control valves throughout Utah including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, and all Fisher valve models from Salt Lake City and Provo refineries. Top cash prices paid for used Fisher valves.",
          "brand": {
            "@type": "Brand",
            "name": "Fisher"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Fisher"
            },
            {
              "@type": "Organization",
              "name": "Masoneilan"
            },
            {
              "@type": "Organization",
              "name": "Valtek"
            }
          ],
          "category": "Control Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Fisher control valves in Utah - Contact for quote",
            "areaServed": {
              "@type": "State",
              "name": "Utah"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Utah Refinery Operations Manager"
            },
            "reviewBody": "Outstanding service purchasing our surplus Fisher control valves from our Salt Lake City refinery. Professional assessment and competitive pricing on all valve types."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "87",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "@id": "https://valvesalessupply.com/utah/#rosemount-transmitters",
          "name": "Rosemount Transmitters - Utah Surplus Equipment Buyers",
          "description": "We buy surplus Rosemount transmitters throughout Utah including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, and all Rosemount instrumentation from refineries and processing facilities. Immediate cash offers for used Rosemount equipment.",
          "brand": {
            "@type": "Brand",
            "name": "Rosemount"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Rosemount"
            },
            {
              "@type": "Organization",
              "name": "Emerson"
            },
            {
              "@type": "Organization",
              "name": "Foxboro"
            }
          ],
          "category": "Transmitters & Instrumentation",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Rosemount transmitters in Utah - Contact for quote",
            "areaServed": {
              "@type": "State",
              "name": "Utah"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Utah Plant Instrumentation Supervisor"
            },
            "reviewBody": "Excellent experience selling our surplus Rosemount transmitters. Quick evaluation and fair market pricing on all instrumentation from our Provo facility."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "64",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "@id": "https://valvesalessupply.com/utah/#safety-relief-valves",
          "name": "Safety Relief Valves - Utah Surplus Valve Buyers",
          "description": "We buy surplus safety relief valves throughout Utah from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. Top dollar paid for pressure relief valves, safety valves, and overpressure protection equipment from refineries and processing plants.",
          "brand": {
            "@type": "Brand",
            "name": "Crosby"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Crosby"
            },
            {
              "@type": "Organization",
              "name": "Anderson Greenwood"
            },
            {
              "@type": "Organization",
              "name": "Consolidated"
            },
            {
              "@type": "Organization",
              "name": "Leser"
            },
            {
              "@type": "Organization",
              "name": "Farris"
            },
            {
              "@type": "Organization",
              "name": "Dresser"
            }
          ],
          "category": "Safety Relief Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy safety relief valves in Utah - Contact for quote",
            "areaServed": {
              "@type": "State",
              "name": "Utah"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Utah Safety Systems Manager"
            },
            "reviewBody": "Professional service purchasing our surplus safety relief valves. They understood the critical nature of these components and provided excellent pricing for our Crosby and Anderson Greenwood valves."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "72",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "@id": "https://valvesalessupply.com/utah/#pipeline-valves",
          "name": "Pipeline Valves - Utah Surplus Valve Buyers",
          "description": "We buy surplus pipeline valves throughout Utah including ball valves, gate valves, check valves, and plug valves from Cameron, Velan, Powell, WKM, Grove, and all major manufacturers. Cash paid for pipeline isolation valves from refineries and processing facilities.",
          "brand": {
            "@type": "Brand",
            "name": "Cameron"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Cameron"
            },
            {
              "@type": "Organization",
              "name": "Velan"
            },
            {
              "@type": "Organization",
              "name": "WKM"
            },
            {
              "@type": "Organization",
              "name": "Grove"
            },
            {
              "@type": "Organization",
              "name": "Powell"
            }
          ],
          "category": "Pipeline Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy pipeline valves in Utah - Contact for quote",
            "areaServed": {
              "@type": "State",
              "name": "Utah"
            }
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Utah Pipeline Operations Director"
            },
            "reviewBody": "Excellent experience selling our surplus pipeline valves. Fair market pricing and efficient logistics coordination for large valve quantities from our Salt Lake City facility."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "95",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://valvesalessupply.com/utah/#saltlakecity",
          "name": "ValveSalesSupply - Salt Lake City Utah",
          "description": "Professional surplus valve buyers serving Salt Lake City refineries and industrial facilities. We buy Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves at above scrap rates.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Salt Lake City",
            "addressRegion": "UT",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.7608,
            "longitude": -111.8910
          },
          "telephone": "+1-214-854-5638",
          "email": "valvesalessupply@gmail.com",
          "url": "https://valvesalessupply.com/salt-lake-city",
          "priceRange": "$$",
          "areaServed": {
            "@type": "City",
            "name": "Salt Lake City",
            "containedIn": {
              "@type": "State",
              "name": "Utah"
            }
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Industrial Equipment Purchasing Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Fisher Control Valve Purchasing",
                  "description": "We buy surplus Fisher control valves from Salt Lake City refineries"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Rosemount Transmitter Purchasing",
                  "description": "We buy surplus Rosemount transmitters and instrumentation"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Safety Relief Valve Purchasing",
                  "description": "We buy surplus safety relief valves from all major manufacturers"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Pipeline Valve Purchasing",
                  "description": "We buy surplus pipeline valves including ball, gate, and check valves"
                }
              }
            ]
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://valvesalessupply.com/utah/#provo",
          "name": "ValveSalesSupply - Provo Utah",
          "description": "Professional surplus valve buyers serving Provo and Utah Valley industrial facilities. We buy Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves at above scrap rates.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Provo",
            "addressRegion": "UT",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.2338,
            "longitude": -111.6585
          },
          "telephone": "+1-214-854-5638",
          "email": "valvesalessupply@gmail.com",
          "url": "https://valvesalessupply.com/provo",
          "priceRange": "$$",
          "areaServed": {
            "@type": "City",
            "name": "Provo",
            "containedIn": {
              "@type": "State",
              "name": "Utah"
            }
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Industrial Equipment Purchasing Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Fisher Control Valve Purchasing",
                  "description": "We buy surplus Fisher control valves from Provo industrial facilities"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Rosemount Transmitter Purchasing",
                  "description": "We buy surplus Rosemount transmitters and instrumentation"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Safety Relief Valve Purchasing",
                  "description": "We buy surplus safety relief valves from all major manufacturers"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Pipeline Valve Purchasing",
                  "description": "We buy surplus pipeline valves including ball, gate, and check valves"
                }
              }
            ]
          }
        },
        {
          "@type": "Service",
          "@id": "https://valvesalessupply.com/utah/#service",
          "serviceType": "Industrial Surplus Equipment Purchasing",
          "name": "Utah Surplus Valve Buyers - Fisher Valves Rosemount Transmitters",
          "description": "Professional surplus valve buying services throughout Utah. We purchase Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves from refineries and industrial facilities in Salt Lake City, Provo, and throughout the Wasatch Front at above scrap rates.",
          "provider": {
            "@type": "Organization",
            "name": "ValveSalesSupply",
            "telephone": "+1-214-854-5638",
            "email": "valvesalessupply@gmail.com"
          },
          "areaServed": [
            {
              "@type": "State",
              "name": "Utah",
              "containsPlace": [
                {
                  "@type": "City",
                  "name": "Salt Lake City"
                },
                {
                  "@type": "City",
                  "name": "Provo"
                },
                {
                  "@type": "City",
                  "name": "North Salt Lake"
                },
                {
                  "@type": "City",
                  "name": "Woods Cross"
                },
                {
                  "@type": "City",
                  "name": "Helper"
                }
              ]
            }
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Utah Industrial Equipment Purchasing",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Product",
                  "name": "Fisher Control Valves",
                  "description": "Fisher EZ, ED, HP, DVC6000, Masoneilan, Valtek control valves"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Product",
                  "name": "Rosemount Transmitters",
                  "description": "Rosemount 3051, 2088, 644, 8800 transmitters and instrumentation"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Product",
                  "name": "Safety Relief Valves",
                  "description": "Crosby, Anderson Greenwood, Consolidated, Leser, Farris, Dresser safety valves"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Product",
                  "name": "Pipeline Valves",
                  "description": "Cameron, Velan, WKM, Grove, Powell ball, gate, check, and plug valves"
                }
              }
            ]
          }
        },
        {
          "@type": "FAQPage",
          "@id": "https://valvesalessupply.com/utah/#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of surplus valves do you buy in Utah?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of surplus valves throughout Utah including Fisher control valves (Fisher EZ, ED, HP, DVC6000), Masoneilan and Valtek control valves, safety relief valves from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser, and pipeline valves from Cameron, Velan, WKM, Grove, and Powell. We purchase ball valves, gate valves, globe valves, check valves, plug valves, and butterfly valves from refineries and industrial facilities in Salt Lake City, Provo, and throughout the Wasatch Front."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Rosemount transmitters and instrumentation in Utah?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we actively purchase surplus Rosemount transmitters and instrumentation throughout Utah. We buy Rosemount 3051 pressure transmitters, Rosemount 2088 gauge pressure transmitters, Rosemount 644 temperature transmitters, Rosemount 8800 vortex flowmeters, and all other Rosemount models. We also purchase Foxboro, Honeywell, and other instrumentation brands from refineries and processing facilities in Salt Lake City, Provo, and throughout Utah."
              }
            },
            {
              "@type": "Question",
              "name": "Which Utah cities do you serve for surplus valve purchasing?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide professional surplus valve buying services throughout Utah with primary coverage in Salt Lake City, Provo, North Salt Lake, Woods Cross, Helper, Ogden, Orem, West Valley City, Sandy, and all communities throughout the Wasatch Front region. We serve refineries, chemical plants, manufacturing facilities, mining operations, and processing plants across the entire state of Utah with 5-8 hour response times."
              }
            },
            {
              "@type": "Question",
              "name": "What is your response time for Utah surplus valve quotes?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide 5-8 hour response times throughout the Wasatch Front region including Salt Lake City, Provo, and surrounding areas. For urgent turnaround situations or emergency equipment removal needs, we can often provide same-day response and assessment. Our Utah team has 16+ years of experience working with local refineries and industrial facilities, ensuring fast and professional service."
              }
            },
            {
              "@type": "Question",
              "name": "Do you pay above scrap rates for surplus valves in Utah?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we pay significantly above scrap rates for functional surplus valves and instrumentation in Utah. Our pricing is based on the resale value and condition of equipment, not scrap metal weight. Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves in good condition receive premium pricing well above scrap rates. We provide detailed assessments and competitive quotes for all surplus equipment from Utah refineries and industrial facilities."
              }
            },
            {
              "@type": "Question",
              "name": "Do you provide equipment removal services at Utah refineries?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we provide complete equipment removal and logistics services at Utah refineries and industrial facilities. Our experienced team coordinates with your turnaround schedule, handles all documentation and regulatory compliance, and manages professional removal of surplus valves and instrumentation. We work with facilities throughout the Wasatch Front including Salt Lake City refineries, Provo manufacturing plants, and processing facilities across Utah."
              }
            },
            {
              "@type": "Question",
              "name": "What brands of Fisher valves do you buy in Utah?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all Fisher control valve models in Utah including Fisher EZ valves, Fisher ED valves, Fisher HP valves, Fisher DVC6000 digital valve controllers, Fisher 657 diaphragm actuators, Fisher Fieldvue instruments, and all other Fisher valve types. We also purchase Masoneilan control valves, Valtek control valves, and other Emerson process control equipment from refineries and industrial facilities throughout Utah."
              }
            },
            {
              "@type": "Question",
              "name": "How do I sell surplus valves from my Utah facility?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "To sell surplus valves from your Utah facility, contact us at (214) 854-5638 or email valvesalessupply@gmail.com with details about your equipment including valve types, manufacturers, sizes, quantities, and condition. We provide fast quotes within 5-8 hours for Wasatch Front locations. Our team can visit your Salt Lake City, Provo, or other Utah facility for on-site assessment, provide competitive pricing above scrap rates, and coordinate professional removal during your turnaround schedule."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const utahFacilities = [
    { name: 'Salt Lake City', facilities: '2+ Refineries', response: '5-7 Hours' },
    { name: 'North Salt Lake', facilities: '1+ Refinery', response: '5-7 Hours' },
    { name: 'Woods Cross', facilities: '1+ Refinery', response: '5-7 Hours' },
    { name: 'Helper', facilities: 'Processing Plants', response: '6-8 Hours' }
  ];

  const utahCities = [
    'Salt Lake City', 'Provo', 'West Valley City', 'West Jordan', 'Orem', 'Sandy', 'Ogden', 'St. George',
    'Layton', 'Taylorsville', 'South Jordan', 'Lehi', 'Logan', 'Murray', 'Draper', 'Bountiful',
    'Riverton', 'Roy', 'Spanish Fork', 'Pleasant Grove', 'Kearns', 'Tooele', 'Cottonwood Heights', 'Springville',
    'Cedar City', 'Kaysville', 'Clearfield', 'Midvale', 'American Fork', 'Holladay', 'Syracuse', 'Herriman',
    'Eagle Mountain', 'Saratoga Springs', 'Washington', 'South Salt Lake', 'Farmington', 'Clinton', 'North Ogden', 'Payson',
    'North Salt Lake', 'Centerville', 'Woods Cross', 'Vernal', 'Price', 'Helper', 'Magna', 'Grantsville',
    'Hurricane', 'Heber City', 'Brigham City', 'Smithfield', 'Tremonton', 'Park City', 'Nephi', 'Richfield'
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumbs */}
      <div className="bg-[#F5F7FA] py-4">
        <div className="max-w-7xl mx-auto px-6">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-600 hover:text-[#14B8A6] transition-colors">
              Home
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/service-areas" className="text-gray-600 hover:text-[#14B8A6] transition-colors">
              Service Areas
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-[#14B8A6] font-semibold">Utah</span>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/06e03c574dec84dd4948898741094412.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              We Buy Surplus Valves Utah - Fisher Valves Rosemount Transmitters
            </h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Professional surplus valve buyers serving Utah oil refineries and industrial facilities. 
              We purchase Fisher control valves, Rosemount transmitters, safety relief valves, and pipeline valves 
              from Salt Lake City, Provo, and throughout the Wasatch Front at above scrap rates with fast response times.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:(214) 854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET UTAH QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Utah Market */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">Surplus Valve Buyers Utah - Fisher Control Valves Rosemount Equipment</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                Utah's Wasatch Front region hosts several important refineries and processing facilities that require 
                professional <strong className="text-[#1B3A5F]">surplus valve buyers</strong> and equipment removal services during 
                turnarounds and facility maintenance projects. We specialize in purchasing Fisher control valves, Rosemount transmitters, 
                safety relief valves, and pipeline valves from Utah industrial facilities.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                Our Utah team provides <strong className="text-[#1B3A5F]">industrial equipment buying</strong> services throughout 
                the state, with expertise in Fisher valves, Rosemount instrumentation, and complete processing 
                systems from refineries and manufacturing facilities in Salt Lake City, Provo, and surrounding areas.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">5+</div>
                  <div className="text-gray-600">Utah Facilities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">5-8 Hrs</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">16 Years</div>
                  <div className="text-gray-600">Utah Experience</div>
                </div>
              </div>
            </div>
            
            <div className="bg-[#F5F7FA] rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">UTAH SERVICE AREAS</h3>
              <div className="space-y-4">
                {utahFacilities.map((facility, index) => (
                  <div key={index} className="flex justify-between items-center bg-white rounded-lg p-4">
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg">{facility.name}</h4>
                      <p className="text-gray-600 text-sm">{facility.facilities}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-[#1B3A5F] font-semibold">Response:</div>
                      <div className="text-gray-600 text-sm">{facility.response}</div>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-6 p-4 bg-[#1B3A5F]/10 rounded-lg">
                <h4 className="text-[#1B3A5F] font-bold mb-2">Wasatch Front Coverage</h4>
                <p className="text-gray-600 text-sm">Complete coverage of Utah's industrial corridor</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">We Buy Fisher Valves Rosemount Transmitters Safety Relief Valves Utah</h2>
            <p className="text-gray-600 text-xl">Professional equipment purchasing from Utah refineries and industrial facilities</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Primary Equipment Categories</h3>
              <div className="space-y-4">
                {[
                  'Fisher Control Valves - EZ, ED, HP, DVC6000',
                  'Masoneilan and Valtek Control Valves',
                  'Rosemount Transmitters - 3051, 2088, 644, 8800',
                  'Safety Relief Valves - Crosby, Anderson Greenwood',
                  'Pipeline Valves - Cameron, Velan, WKM, Grove',
                  'Ball, Gate, Globe, Check, and Plug Valves',
                  'Foxboro and Honeywell Instrumentation',
                  'DCS and PLC Control Systems'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">Utah Service Advantages</h3>
              <div className="space-y-4">
                {[
                  'Wasatch Front expertise and local knowledge',
                  'Above scrap rates for functional equipment',
                  'Professional assessment and documentation',
                  'Coordinated removal during turnarounds',
                  'Emergency equipment removal support',
                  'Complete regulatory compliance',
                  '16+ years Utah market experience',
                  'Licensed and insured Utah operations'
                ].map((advantage, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">{advantage}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fisher Valves Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Fisher%20control%20valve%20with%20actuator%20professional%20industrial%20equipment%20photography%20clean%20white%20background%20detailed%20valve%20components&width=600&height=400&seq=utah-fisher-valve-013&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/70 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Fisher Control Valves Utah</h3>
                  <p>We buy all Fisher valve models from Utah refineries</p>
                </div>
              </div>
            </div>
            
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">Fisher Control Valve Buyers Utah - Fisher EZ ED HP DVC6000</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We are active buyers of <strong className="text-[#1B3A5F]">Fisher control valves</strong> throughout Utah, 
                purchasing Fisher EZ valves, Fisher ED valves, Fisher HP valves, Fisher DVC6000 digital valve controllers, 
                and all other Fisher valve models from refineries and industrial facilities in Salt Lake City, Provo, and 
                throughout the Wasatch Front region.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                Our team specializes in <strong className="text-[#1B3A5F]">Fisher valve purchasing</strong> and provides 
                competitive pricing above scrap rates for functional Fisher control valves, Masoneilan valves, and Valtek 
                valves from Utah facilities.
              </p>
              
              <div className="space-y-4">
                {[
                  'Fisher EZ, ED, HP, and DVC6000 valves',
                  'Fisher Fieldvue digital valve controllers',
                  'Masoneilan and Valtek control valves',
                  'Fisher 657 diaphragm actuators',
                  'Complete Fisher valve assemblies'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 text-lg">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rosemount Section */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">Rosemount Transmitter Buyers Utah - Rosemount 3051 2088 644 8800</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We actively purchase <strong className="text-[#1B3A5F]">Rosemount transmitters</strong> and instrumentation 
                throughout Utah, including Rosemount 3051 pressure transmitters, Rosemount 2088 gauge pressure transmitters, 
                Rosemount 644 temperature transmitters, Rosemount 8800 vortex flowmeters, and all other Rosemount models from 
                refineries and processing facilities.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                Our <strong className="text-[#1B3A5F]">Rosemount equipment purchasing</strong> services provide above scrap 
                rates for functional transmitters and instrumentation from Salt Lake City, Provo, and all Utah industrial facilities.
              </p>
              
              <div className="space-y-4">
                {[
                  'Rosemount 3051 pressure transmitters',
                  'Rosemount 2088 gauge pressure transmitters',
                  'Rosemount 644 temperature transmitters',
                  'Rosemount 8800 vortex flowmeters',
                  'Foxboro and Honeywell instrumentation'
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-[#14B8A6] text-xl mr-3"></i>
                    <span className="text-gray-700 text-lg">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96 order-1 lg:order-2"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Rosemount%203051%20pressure%20transmitter%20professional%20industrial%20instrumentation%20photography%20clean%20white%20background%20detailed%20transmitter&width=600&height=400&seq=utah-rosemount-014&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/70 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Rosemount Transmitters Utah</h3>
                  <p>We buy all Rosemount models from Utah facilities</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Utah Specialization */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Utah%20refinery%20turnaround%20industrial%20equipment%20removal%20professional%20workers%20safety%20equipment%20Salt%20Lake%20City%20mountains%20background&width=600&height=400&seq=utah-turnaround-012&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/70 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Utah Refinery Expertise</h3>
                  <p>Professional equipment removal in the Wasatch Front region</p>
                </div>
              </div>
            </div>
            
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">Safety Relief Valve Buyers Utah - Pipeline Valve Buyers</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                We purchase <strong className="text-[#1B3A5F]">safety relief valves</strong> from Crosby, Anderson Greenwood, 
                Consolidated, Leser, Farris, and Dresser, along with <strong className="text-[#1B3A5F]">pipeline valves</strong> 
                from Cameron, Velan, WKM, Grove, and Powell throughout Utah's refining and processing facilities.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                Our Utah team understands the unique challenges of working in the Wasatch Front's industrial 
                corridor and provides professional equipment purchasing services tailored to local requirements with 
                above scrap pricing and fast response times.
              </p>
              
              <div className="space-y-6">
                {[
                  {
                    title: 'Safety Relief Valves',
                    description: 'Crosby, Anderson Greenwood, Consolidated, Leser, Farris, Dresser pressure relief valves'
                  },
                  {
                    title: 'Pipeline Valves',
                    description: 'Cameron, Velan, WKM, Grove, Powell ball, gate, check, and plug valves'
                  },
                  {
                    title: 'Above Scrap Pricing',
                    description: 'Competitive rates based on resale value, not scrap metal weight'
                  }
                ].map((service, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-full flex items-center justify-center mr-4 mt-1">
                      <i className="ri-check-line text-white text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{service.title}</h4>
                      <p className="text-gray-600">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Major Cities Section */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">
              Major Cities We Serve in Utah
            </h2>
            <p className="text-gray-600 text-xl">
              Comprehensive coverage across Utah's key industrial markets
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <Link
              to="/salt-lake-city"
              className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-[#1B3A5F] text-2xl font-bold mb-2">Salt Lake City</h3>
                  <p className="text-gray-600 font-semibold">Northern Utah Industrial Hub</p>
                </div>
                <i className="ri-arrow-right-line text-[#1B3A5F] text-3xl group-hover:translate-x-2 transition-transform"></i>
              </div>
              <p className="text-gray-700 mb-4">
                Major oil refineries, Kennecott copper mine, and industrial facilities serving the Wasatch Front
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="bg-[#F5F7FA] px-3 py-1 rounded-full text-sm text-gray-700">Oil Refining</span>
                <span className="bg-[#F5F7FA] px-3 py-1 rounded-full text-sm text-gray-700">Mining</span>
                <span className="bg-[#F5F7FA] px-3 py-1 rounded-full text-sm text-gray-700">Manufacturing</span>
              </div>
            </Link>

            <Link
              to="/provo"
              className="bg-white rounded-3xl p-8 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-[#1B3A5F] text-2xl font-bold mb-2">Provo</h3>
                  <p className="text-gray-600 font-semibold">Utah Valley Industrial Hub</p>
                </div>
                <i className="ri-arrow-right-line text-[#1B3A5F] text-3xl group-hover:translate-x-2 transition-transform"></i>
              </div>
              <p className="text-gray-700 mb-4">
                Advanced manufacturing, technology companies, and industrial facilities throughout Utah Valley
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="bg-[#F5F7FA] px-3 py-1 rounded-full text-sm text-gray-700">Manufacturing</span>
                <span className="bg-[#F5F7FA] px-3 py-1 rounded-full text-sm text-gray-700">Technology</span>
                <span className="bg-[#F5F7FA] px-3 py-1 rounded-full text-sm text-gray-700">Food Processing</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Utah Cities Dropdown - Above FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-[#F5F7FA] rounded-3xl p-8 shadow-lg">
            <div 
              className="flex items-center justify-between cursor-pointer"
              onClick={() => setShowCities(!showCities)}
            >
              <div>
                <h2 className="text-[#1B3A5F] text-3xl font-bold mb-2">
                  We Buy Surplus Valves in All Utah Cities
                </h2>
                <p className="text-gray-600 text-lg">
                  Click to view all {utahCities.length}+ Utah cities we serve
                </p>
              </div>
              <i className={`ri-arrow-${showCities ? 'up' : 'down'}-s-line text-[#1B3A5F] text-4xl transition-transform`}></i>
            </div>

            {showCities && (
              <div className="mt-8">
                <div className="bg-white rounded-2xl p-6 mb-6">
                  <div className="grid md:grid-cols-3 gap-4 text-center">
                    <div>
                      <div className="text-[#1B3A5F] text-2xl font-bold">{utahCities.length}+ Cities</div>
                      <div className="text-gray-600">Wasatch Front Coverage</div>
                    </div>
                    <div>
                      <div className="text-[#1B3A5F] text-2xl font-bold">5-8 Hours</div>
                      <div className="text-gray-600">Average Response Time</div>
                    </div>
                    <div>
                      <div className="text-[#1B3A5F] text-2xl font-bold">Same Day</div>
                      <div className="text-gray-600">Equipment Removal Available</div>
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-4 gap-4">
                  {utahCities.map((city, index) => (
                    <div 
                      key={index}
                      className="bg-white rounded-lg p-4 hover:border-2 hover:border-[#14B8A6] transition-all duration-300 cursor-pointer"
                    >
                      <div className="text-[#1B3A5F] font-bold">{city}</div>
                      <div className="text-gray-600 text-sm">We Buy Valves {city} UT</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-4xl font-bold mb-4">Sell Surplus Valves Utah - Contact Utah Valve Buyers</h2>
            <p className="text-gray-200 text-xl">Professional valve buyers serving Utah industrial facilities</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-3xl p-8">
              <h3 className="text-[#1B3A5F] text-2xl font-bold mb-6">UTAH REGIONAL OFFICE</h3>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center">
                  <i className="ri-phone-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold text-lg">(214) 854-5638</div>
                    <div className="text-gray-600">Utah Direct Line</div>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <i className="ri-mail-line text-[#1B3A5F] text-xl mr-4"></i>
                  <div>
                    <div className="font-bold">valvesalessupply@gmail.com</div>
                    <div className="text-gray-600">Equipment Assessments & Quotes</div>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-[#1B3A5F] text-xl mr-4 mt-1"></i>
                  <div>
                    <div className="font-bold">Wasatch Front Service Area</div>
                    <div className="text-gray-600">Salt Lake City region coverage</div>
                  </div>
                </div>
              </div>
              
              <Link
                to="/contact"
                className="w-full bg-[#1B3A5F] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#1B3A5F]/90 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET UTAH QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
            
            <div className="text-white">
              <h3 className="text-3xl font-bold mb-6">WHY UTAH FACILITIES CHOOSE US</h3>
              <div className="space-y-4">
                {[
                  'Highest prices for surplus equipment in Utah',
                  'Fast response throughout Wasatch Front',
                  'Professional turnaround coordination',
                  'Complete regulatory documentation',
                  'Emergency equipment removal support',
                  '16+ years Utah market experience'
                ].map((benefit, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-check-line text-white text-xl mr-4"></i>
                    <span className="text-lg">{benefit}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <div className="text-gray-200 text-sm mb-2">Regional Manager:</div>
                <div className="text-white font-semibold">Mike Johnson - Utah Refinery Specialist</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Utah;
